import React, { useEffect } from 'react';
import { GameProvider, useGame } from './context/GameContext';
import HomePage from './pages/HomePage';
import LobbyPage from './pages/LobbyPage';
import GamePage from './pages/GamePage';
import './App.css';

/**
 * Main App Router - Renders appropriate page based on game state
 */
const AppContent = () => {
  const { game, joinExistingGame } = useGame();

  // Handle join link from URL - pre-fill join mode
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const joinCode = params.get('join');
    if (joinCode && !game) {
      // Store the join code so HomePage can use it
      sessionStorage.setItem('pendingJoinCode', joinCode);
      // Clear the URL parameter
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [game]);

  // No game - show home page
  if (!game) {
    return <HomePage />;
  }

  // Game waiting for players - show lobby
  if (game.status === 'waiting') {
    return <LobbyPage />;
  }

  // Game in progress or finished - show game page
  return <GamePage />;
};

/**
 * App wrapper with GameProvider
 */
const App = () => {
  return (
    <GameProvider>
      <AppContent />
    </GameProvider>
  );
};

export default App;

